import React from 'react';

// Bootstrap 4 spinner; `block` centres it as a section placeholder, otherwise it is a small spinner that sits inline next to text or inside a button.
export default function Spinner({ label, block = false, className = '' }) {
    const spinner = (
        <span
            className={`spinner-border${block ? '' : ' spinner-border-sm'}${className ? ` ${className}` : ''}`}
            role="status"
            data-testid="demo-spinner"
        >
            <span className="sr-only">{label}</span>
        </span>
    );

    return block ? <div className="d-flex justify-content-center py-3 demo-spinner-block">{spinner}</div> : spinner;
}
